import React from 'react';
import theme from '../theme';

const Terms = () => {
  const styles = {
    container: {
      maxWidth: '900px',
      margin: '0 auto',
      padding: `${theme.spacing['2xl']} ${theme.spacing.md}`,
    },
    title: {
      fontSize: theme.typography.fontSize['4xl'],
      fontWeight: theme.typography.fontWeight.bold,
      color: theme.colors.text,
      marginBottom: theme.spacing.md,
      fontFamily: theme.typography.fontFamily.heading,
    },
    intro: {
      fontSize: theme.typography.fontSize.base,
      color: theme.colors.textSecondary,
      lineHeight: theme.typography.lineHeight.relaxed,
      marginBottom: theme.spacing.lg,
      fontFamily: theme.typography.fontFamily.primary,
    },
    section: {
      marginBottom: theme.spacing.xl,
      padding: theme.spacing.lg,
      border: `1px solid ${theme.colors.border}`,
      borderRadius: theme.borderRadius.lg,
      backgroundColor: theme.colors.backgroundGray,
    },
    languageLabel: {
      fontSize: theme.typography.fontSize.sm,
      color: theme.colors.textSecondary,
      marginBottom: theme.spacing.md,
      fontFamily: theme.typography.fontFamily.primary,
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      fontWeight: theme.typography.fontWeight.semibold,
    },
    sectionItem: {
      marginBottom: theme.spacing.lg,
    },
    itemTitle: {
      fontSize: theme.typography.fontSize.lg,
      fontWeight: theme.typography.fontWeight.semibold,
      color: theme.colors.text,
      marginBottom: theme.spacing.xs,
      fontFamily: theme.typography.fontFamily.heading,
    },
    paragraph: {
      fontSize: theme.typography.fontSize.base,
      color: theme.colors.textSecondary,
      lineHeight: theme.typography.lineHeight.relaxed,
      marginBottom: 0,
      fontFamily: theme.typography.fontFamily.primary,
    },
    list: {
      marginTop: theme.spacing.sm,
      marginBottom: 0,
      paddingLeft: theme.spacing.lg,
      color: theme.colors.textSecondary,
      fontFamily: theme.typography.fontFamily.primary,
      lineHeight: theme.typography.lineHeight.relaxed,
    },
    listItem: {
      marginBottom: theme.spacing.xs,
    },
    rtl: {
      direction: 'rtl',
      textAlign: 'right',
    },
    rtlList: {
      paddingRight: theme.spacing.lg,
      paddingLeft: 0,
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>WODGoat Terms &amp; Conditions</h1>
      <p style={styles.intro}>Effective Date: March 3, 2026</p>

      <div style={styles.section}>
        <p style={styles.languageLabel}>English</p>
        <div style={styles.sectionItem}>
          <h3 style={styles.itemTitle}>1. Introduction</h3>
          <p style={styles.paragraph}>WODGoat ("we", "our", or "us") operates the WODGoat mobile app (the "App").</p>
          <p style={styles.paragraph}>By using the App, you agree to these Terms &amp; Conditions.</p>
        </div>

        <div style={styles.sectionItem}>
          <h3 style={styles.itemTitle}>2. Eligibility</h3>
          <p style={styles.paragraph}>You must be at least 13 years old to use the App.</p>
        </div>

        <div style={styles.sectionItem}>
          <h3 style={styles.itemTitle}>3. Accounts</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Sign up via Email, Apple, or Google</li>
            <li style={styles.listItem}>Keep account credentials confidential</li>
          </ul>
        </div>

        <div style={styles.sectionItem}>
          <h3 style={styles.itemTitle}>4. Subscriptions &amp; Billing</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Monthly, quarterly, yearly subscriptions available</li>
            <li style={styles.listItem}>Payments via Apple App Store or Google Play</li>
            <li style={styles.listItem}>Subscriptions renew automatically unless canceled</li>
          </ul>
        </div>

        <div style={styles.sectionItem}>
          <h3 style={styles.itemTitle}>5. Health Disclaimer</h3>
          <p style={styles.paragraph}>The App provides fitness content for informational purposes only.</p>
          <p style={styles.paragraph}>We do not provide medical advice.</p>
          <p style={styles.paragraph}>Exercise involves risk; use at your own responsibility.</p>
        </div>

        <div style={styles.sectionItem}>
          <h3 style={styles.itemTitle}>6. Account Deletion</h3>
          <p style={styles.paragraph}>You may delete your account directly in the App.</p>
          <p style={styles.paragraph}>All associated data will be deleted per our Privacy Policy.</p>
        </div>

        <div style={styles.sectionItem}>
          <h3 style={styles.itemTitle}>7. Intellectual Property</h3>
          <p style={styles.paragraph}>All content, design, and software are owned by WODGoat.</p>
          <p style={styles.paragraph}>Unauthorized copying or redistribution is prohibited.</p>
        </div>

        <div style={styles.sectionItem}>
          <h3 style={styles.itemTitle}>8. Governing Law</h3>
          <p style={styles.paragraph}>These Terms are governed by the laws of the Arab Republic of Egypt.</p>
        </div>

        <div style={styles.sectionItem}>
          <h3 style={styles.itemTitle}>9. Contact</h3>
          <p style={styles.paragraph}>wodgoat@gmail.com</p>
        </div>
      </div>

      <div style={styles.section}>
        <p style={styles.languageLabel}>العربية</p>
        <div style={styles.rtl}>
          <div style={styles.sectionItem}>
            <h3 style={styles.itemTitle}>الشروط والأحكام لتطبيق WODGoat</h3>
            <p style={styles.paragraph}>تاريخ السريان: March 3, 2026</p>
          </div>

          <div style={styles.sectionItem}>
            <h3 style={styles.itemTitle}>1. المقدمة</h3>
            <p style={styles.paragraph}>يتم تشغيل تطبيق WODGoat ("نحن") بواسطة يحيى محمد أنس.</p>
            <p style={styles.paragraph}>باستخدامك التطبيق، فإنك توافق على هذه الشروط والأحكام.</p>
          </div>

          <div style={styles.sectionItem}>
            <h3 style={styles.itemTitle}>2. الأهلية</h3>
            <p style={styles.paragraph}>يجب أن يكون عمرك 13 عامًا أو أكثر لاستخدام التطبيق.</p>
          </div>

          <div style={styles.sectionItem}>
            <h3 style={styles.itemTitle}>3. الحسابات</h3>
            <ul style={{ ...styles.list, ...styles.rtlList }}>
              <li style={styles.listItem}>التسجيل عبر البريد الإلكتروني أو Apple أو Google</li>
              <li style={styles.listItem}>الاحتفاظ بسرية بيانات الحساب</li>
            </ul>
          </div>

          <div style={styles.sectionItem}>
            <h3 style={styles.itemTitle}>4. الاشتراكات والمدفوعات</h3>
            <ul style={{ ...styles.list, ...styles.rtlList }}>
              <li style={styles.listItem}>اشتراكات شهرية، ربع سنوية، سنوية متاحة</li>
              <li style={styles.listItem}>المدفوعات عبر Apple App Store أو Google Play</li>
              <li style={styles.listItem}>يتم التجديد تلقائيًا ما لم يتم الإلغاء</li>
            </ul>
          </div>

          <div style={styles.sectionItem}>
            <h3 style={styles.itemTitle}>5. إخلاء المسؤولية الصحية</h3>
            <p style={styles.paragraph}>يقدم التطبيق محتوى لياقة لأغراض معلوماتية فقط.</p>
            <p style={styles.paragraph}>لا نقدم نصائح طبية.</p>
            <p style={styles.paragraph}>التمارين تحمل مخاطر، وتتحمل المسؤولية كاملة.</p>
          </div>

          <div style={styles.sectionItem}>
            <h3 style={styles.itemTitle}>6. حذف الحساب</h3>
            <p style={styles.paragraph}>يمكنك حذف الحساب مباشرة داخل التطبيق.</p>
            <p style={styles.paragraph}>سيتم حذف جميع البيانات المرتبطة وفق سياسة الخصوصية.</p>
          </div>

          <div style={styles.sectionItem}>
            <h3 style={styles.itemTitle}>7. الملكية الفكرية</h3>
            <p style={styles.paragraph}>جميع المحتويات، التصاميم، والبرمجيات مملوكة لتطبيق WODGoat.</p>
            <p style={styles.paragraph}>يُمنع النسخ أو إعادة التوزيع غير المصرح به.</p>
          </div>

          <div style={styles.sectionItem}>
            <h3 style={styles.itemTitle}>8. القانون الحاكم</h3>
            <p style={styles.paragraph}>تخضع هذه الشروط لقوانين جمهورية مصر العربية.</p>
          </div>

          <div style={styles.sectionItem}>
            <h3 style={styles.itemTitle}>9. التواصل</h3>
            <p style={styles.paragraph}>wodgoat@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
